var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"inner"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{attrs:{"src":_vm.logourl,"onerror":"src='/static/img/logo.png'"}})]),_vm._v(" "),_c('span',[_vm._v("您好，欢迎登录"+_vm._s(_vm.$store.state.webInfo.name)+"商城！")])],1)]),_vm._v(" "),_c('div',{staticClass:"conter",style:({
      backgroundImage:
        'url(' +
        (_vm.$store.state.webInfo.mall_login_bg == ''
          ? '/static/img/pclogos.jpg'
          : _vm.$store.state.webInfo.mall_login_bg) +
        ')',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    })},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('div',{staticClass:"login-box",staticStyle:{"position":"absolute","right":"80px","top":"80px"}},[_c('vLogin')],1)])]),_vm._v(" "),_c('div',[_c('el-footer',{staticStyle:{"background":"#ffffff","height":"183px","padding":"0"}},[_c('vLoginFooter')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ef829e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/index.vue
// module id = null
// module chunks = 